import { render, staticRenderFns } from "./AdminImportDriversContract.vue?vue&type=template&id=c8f1db7a&scoped=true&"
import script from "./AdminImportDriversContract.vue?vue&type=script&lang=js&"
export * from "./AdminImportDriversContract.vue?vue&type=script&lang=js&"
import style0 from "./AdminImportDriversContract.vue?vue&type=style&index=0&id=c8f1db7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f1db7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8f1db7a')) {
      api.createRecord('c8f1db7a', component.options)
    } else {
      api.reload('c8f1db7a', component.options)
    }
    module.hot.accept("./AdminImportDriversContract.vue?vue&type=template&id=c8f1db7a&scoped=true&", function () {
      api.rerender('c8f1db7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminImportDriversContract.vue"
export default component.exports